/*
 *
 * CostsDebitDetailsDownloadModal
 *
 * @version 1.0.0
 * @author Ivana Piscitelli
 * @since 20-Aug-2025
*/

// import React from 'react'
// import PortalMessage from 'Utility/PortalMessage'

const formattedMessage = {

}

export default formattedMessage
